/**
 * Check Transaction that it is specified function invoke
 * @param {Transaction} transaction
 * @param {String} signature AbiItem Signature for event
 * @param {String} contractAddress Address filter for logs
 */
export function hasTransactionEvent ({ receipt, signature, eventAddress = null }) {
  if (!receipt) return null
  const filteredLogs = (receipt?.logs || [])
    .filter((item) => eventAddress === null || item?.address?.toLowerCase() === eventAddress?.toLowerCase())
  for (const log of filteredLogs) {
    for (const topic of (log?.topics || [])) {
      if (topic === signature) return true
    }
  }
  return false
}
